import List from "#SRC/js/structs/List";
import PodTerminationHistory from "./PodTerminationHistory";

class PodTerminationHistoryList extends List {}

PodTerminationHistoryList.type = PodTerminationHistory;

module.exports = PodTerminationHistoryList;



// WEBPACK FOOTER //
// ./plugins/services/src/js/structs/PodTerminationHistoryList.js